import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../ui/button';
import { WidgetEmpty } from '../WidgetCard';
import { dashboardAPI } from '../../../lib/api';
import { Sparkles, X } from 'lucide-react';

export const WhatsNewWidget = ({ data, preferences, onRefresh }) => {
  const navigate = useNavigate();
  if (!data?.version) {
    return <WidgetEmpty testId="whats-new-widget-empty">No release notes yet.</WidgetEmpty>;
  }
  if (preferences?.dismissed_release === data.version) {
    return <WidgetEmpty testId="whats-new-widget-dismissed">
      You&apos;re up to date on {data.version}.
    </WidgetEmpty>;
  }

  const dismiss = async () => {
    try {
      await dashboardAPI.savePreferences({ dismissed_release: data.version });
      onRefresh();
    } catch { /* non-blocking */ }
  };

  return (
    <div className="flex items-start gap-2.5" data-testid="whats-new-widget">
      <Sparkles className="w-4 h-4 mt-0.5 text-[hsl(var(--brand-accent))] shrink-0" />
      <div className="min-w-0 flex-1">
        <button type="button" onClick={() => navigate('/whats-new')}
          className="text-sm text-fg text-left hover:underline"
          data-testid="whats-new-widget-link">
          <b>{data.version}</b> — {data.headline || 'See what changed'}
        </button>
      </div>
      <Button variant="ghost" size="icon" className="h-6 w-6 text-fg-muted shrink-0"
        aria-label="Dismiss release note" onClick={dismiss}
        data-testid="whats-new-widget-dismiss">
        <X className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
};

export default WhatsNewWidget;
